// Kept out of index.js so the drawer can read them without importing the page
// back (which would be a cycle).

// Meesho label sheets and Myntra picklists can be read today; the rest are
// listed so the intent of the field is clear, and get enabled as their parsers
// land.
export const PLATFORMS = [
  { value: 3, label: "Meesho", supported: true },
  { value: 2, label: "Flipkart", supported: false },
  { value: 5, label: "Myntra", supported: true },
  { value: 1, label: "Amazon", supported: false },
];

export const platformLabel = (value) =>
  PLATFORMS.find((p) => p.value === Number(value))?.label ?? "-";

export const STATUSES = [
  { value: "completed", label: "Completed" },
  { value: "partial", label: "Partial" },
  { value: "failed", label: "Failed" },
];

export const QUICK_RANGES = [
  { key: "today", label: "Today", back: 0 },
  { key: "7d", label: "Last 7D", back: 6 },
  { key: "30d", label: "Last 30D", back: 29 },
];
